import { Component, OnInit, NgZone, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, ViewRef } from '@angular/core';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4themes_material from "@amcharts/amcharts4/themes/material";
import { ChartsService } from '../charts-service/charts.service';
import { QueryParamsModel, LayoutUtilsService } from 'app/core/_base/crud';
import moment from 'moment';
import { ReplaySubject } from 'rxjs';
import { DatePipe } from '@angular/common';
import { DungChungService } from '../../dung-chung/__services/dung-chung.service';
import { CommonConFig } from '../../dung-chung/__model/common_config.model';
am4core.useTheme(am4themes_material);
@Component({
  selector: 'kt-theo-doi-khoi-luong-nhap-kho-chart',
  templateUrl: './theo-doi-khoi-luong-nhap-kho-chart.component.html',
  styleUrls: ['./theo-doi-khoi-luong-nhap-kho-chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DatePipe]
})
export class TheoDoiKhoiLuongNhapKhoChartComponent implements OnInit {

  chartPie: am4charts.PieChart;

  CONFIG: CommonConFig;




  TuNgay;
  DenNgay;

  config = {

  }
  constructor(
    private zone: NgZone,
    private chartsservice: ChartsService,
    private changeDetect: ChangeDetectorRef,
    private DungChungService: DungChungService,
    private layoutUtilsService: LayoutUtilsService,
  ) {

  }
  ngAfterViewInit(): void {

    // this.loadBieuDo();
  }

  configChartPie(value, category, data) {
    this.zone.runOutsideAngular(() => {
      if (this.chartPie) {
        this.chartPie.dispose();
      }
      var chart = am4core.create("charttkhtPie1", am4charts.PieChart);
      chart.legend = new am4charts.Legend();
      chart.logo.height = -100;
      // Add data
      chart.data = data;
      // Add and configure Series
      var pieSeries = chart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = value;
      pieSeries.dataFields.category = category;
      pieSeries.ticks.template.disabled = true;
      pieSeries.labels.template.disabled = true;
      pieSeries.alignLabels = false;
      // pieSeries.labels.template.text = "{value.percent.formatNumber('#.0')}%";
      // pieSeries.labels.template.radius = am4core.percent(-40);
      // pieSeries.labels.template.fill = am4core.color("white");
      // pieSeries.labels.template.relativeRotation = 90;
      this.chartPie = chart;
    });
    this.changeDetectView();
  }
  ngOnDestroy() {

  }
  ngOnInit() {
    this.CONFIG = new CommonConFig();
    this.LoadDataPie();
    this.changeDetectView();
  }



  LoadDataPie() {
    let tungay = null;
    let denngay = null;
    if (this.TuNgay) {
      tungay = moment(this.TuNgay).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
    }
    if (this.DenNgay) {
      denngay = moment(this.DenNgay).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
    }
    this.chartsservice.TheoDoiKhoiLuongNhapKho(tungay, denngay).subscribe(res => {
      let result = res.data.items;
      this.configChartPie("Totals", "Xtext", result);
    });
  }
  changeDetectView() {
    if (!(this.changeDetect as ViewRef).destroyed) {
      this.changeDetect.detectChanges()
    }
  }
  loadBieuDo() {

  }

}